import React from "react";
import AppRoot from "./components/layout/AppRoot";

function App() {
  return <AppRoot />;
}

export default App;
